import { Flex, Spinner, ThemingProps } from '@chakra-ui/react';
import { TooltipStandard } from 'components/tooltip/TooltipStandard';
interface ILoadingSpinnerProps {
	message?: string;
	size?: ThemingProps<'Spinner'>['size'];
	speed?: string;
	emptyColor?: string;
	color?: string;
	label?: string;
	[key: string]: any;
}
export const LoadingSpinner = ({
	message = 'Carregando dados...',
	size = 'lg',
	speed = '0.65s',
	emptyColor = 'gray.200',
	color = 'blue.500',
	label = '',
	...props
}: ILoadingSpinnerProps) => {
	return (
		<Flex
			w='100%'
			flexDirection='column'
			justifyContent='center'
			alignItems='center'
			{...props}
		>
			<TooltipStandard label={label}>
				<Spinner
					thickness='4px'
					speed={speed}
					emptyColor={emptyColor}
					color={color}
					size={size}
				/>
			</TooltipStandard>
			{message && <p>{message}</p>}
		</Flex>
	);
};
